import { Injectable } from "@angular/core";
import { Ordonnance } from "@jack-sparrow-libraries/emotion-models/lib/emotion.model";
import { DroitPatient, ReponseAdr, SupportDroitsData } from "@jack-sparrow-libraries/emotion-models";

@Injectable({
	providedIn: "root",
})
export class OrdonnanceEffectHelperService {
	static getSupportDroitsData(
		isAdr: boolean,
		ordonnance: Ordonnance,
		droitsPatientCV: DroitPatient | null,
		adrResponse?: ReponseAdr | null,
	): SupportDroitsData {
		const supportDroitsData = { ...ordonnance.supportDroitsData };
		if (isAdr && adrResponse) {
			supportDroitsData.id = adrResponse?.supportDroitsDataId;
		} else if (droitsPatientCV?.supportDroitsAMO?.supportDroitsDataId) {
			supportDroitsData.id = droitsPatientCV?.supportDroitsAMO?.supportDroitsDataId;
		}
		return supportDroitsData;
	}
}
